export var ScopeSet;
(function (ScopeSet) {
    ScopeSet[ScopeSet["default"] = 4] = "default";
    ScopeSet[ScopeSet["viewer"] = 5] = "viewer";
})(ScopeSet || (ScopeSet = {}));
